export default [
  {
    title: "Products",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Products List",
        route: "custom-module",
        path: "/custom-module/privilege",
      },
    ],
  },
];
